import React from "react";
import { useIntl } from "react-intl";
import { DashboaredHeaderBanner } from "../../../components/sharedComponents/DashboaredHeaderBanner";

export const ServicesHeader = () => {
    const { messages } = useIntl();
    return (
        <div className="container-fluid">
            {/* <div className="head_box">
        <h2 className="heading_dash mb-1">{messages["packages"]}</h2>
        <p className="heading_dis">{messages["packages_info"]}</p>
      </div> */}
            <DashboaredHeaderBanner
                text={messages["packages"]}
                description={messages["packages_info"]}
            />
        </div>
    );
};
